import { useFleetRoute } from '../../router/useFleetRoute.ts';
import { Dashboard } from './views/Dashboard.tsx';
import { RobotList } from './views/RobotList.tsx';
import { RobotDetail } from './views/RobotDetail.tsx';
import { FleetMap } from './views/FleetMap.tsx';
import { Teleop } from './views/Teleop.tsx';
import { ScanViewer } from './views/ScanViewer.tsx';

export function FleetWorkspace() {
  const { view } = useFleetRoute();

  switch (view) {
    case 'dashboard':
      return <Dashboard />;
    case 'list':
      return <RobotList />;
    case 'map':
      return <FleetMap />;
    case 'detail':
      return <RobotDetail />;
    case 'teleop':
      return <Teleop />;
    case 'scan':
      return <ScanViewer />;
  }
}
